<div
  #container
  ngDraggable
  [handle]="dragHandle"
  class="container flex column"
  [ngStyle]="{ width: vm.windowWidth, height: vm.windowHeight }"
>
  <div #dragHandle class="flex row space-between header">
    <div class="flex column justify-center">
      <h2>
        {{ vm.channelTarget.availabilityZoneName }} -
        {{ vm.channelTarget.channelName }} - {{ vm.channelTarget.name }}
      </h2>
    </div>
    <div class="flex row justify-center window-buttons">
      <evrideo-x-button
        (mousedown)="vm.closeWindow()"
        [overrideStyle]="{
          'margin-top': '-0.11vw',
          width: '1.15vw',
          height: '1.15vw'
        }"
      ></evrideo-x-button>
    </div>
  </div>

  <div class="flex column body">
    <ng-container *ngIf="vm.state === 'ready'">
      <div class="flex row fill-height justify-center">
        <div class="flex column justify-center">
          <div class="flex row space-between fill-width">
            <div class="y-label">kbit/s</div>
            <div class="chart-duration">
              <icn-dropdown
                [allowMultiple]="false"
                [(selectedValue)]="vm.selectedTimeMins"
                (selectedValueChange)="vm.showChannelTargetChart()"
              >
                <icn-dropdown-item
                  [title]="'Hour'"
                  [value]="60"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'6 Hours'"
                  [value]="60 * 6"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Day'"
                  [value]="60 * 24"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Week'"
                  [value]="60 * 24 * 7"
                ></icn-dropdown-item>
              </icn-dropdown>
            </div>
          </div>

          <div>
            <evrideo-monitoring-chart
              *ngIf="vm.channelInputChartUrl"
              [url]="vm.channelInputChartUrl"
            ></evrideo-monitoring-chart>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="vm.state === 'loading'">
      <div class="flex row fill-height justify-center">
        <div class="flex column justify-center">
          <h1>Loading...</h1>
        </div>
      </div>
    </ng-container>
  </div>
</div>
